import Vue from "vue";
import ListSfLeverRepository from "@/repositories/monocle/ListSfLeverRepository";

export interface MonocleLever {
    uuid: string;
    label: string;
}

export default {
    state: {
        levers: [],
    },
    mutations: {
        setMonocleLevers: (
            state: any,
            levers: MonocleLever[]
        ) => {
            Vue.set(state, "levers", levers);
        },
    },
    getters: {
        getMonocleLevers: (state: any): MonocleLever[] => {
            return state.levers;
        },
    },
    actions: {
        loadMonocleLevers: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                const orders = { default: "DESC", label: "ASC" };
                const params = { orders };
                ListSfLeverRepository.get(params).then((data: any) => {
                    commit("setMonocleLevers", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
